import styles from "./EditSectionReusable.module.css";
import { useEffect, useImperativeHandle, useRef, useState } from "react";

import { scroller, Link } from "react-scroll";
import edit_1 from "../../../assets/images/edit_screen/TypeA20/edit_1.png";
import EditScreenSelector from "../../Reusables/EditScreenSelector";
import React from "react";
import EditScreenImageUpload from "../../Reusables/EditScreenImageUpload";
import { JAPANESE_REGEX } from "../../../constants";

import domtoimage from "dom-to-image";
const EditSectionReusable = React.forwardRef((props, ref) => {
  const {
    index,
    callback,
    saveThisProduct,
    changeCopyDetails,
    selectedCopyDetails,
    currentPageNumber,
    totalPageNumber,
    callbackPreviewChange,
    state,
    confirmEdits,
    image_selection_popup,
    generatePreviewsAtBottom,
  } = props;
  let {
    lang,
    sec03textbox,
    sec04textbox,
    showPreview,
    titleText,
    backCover01Text,
    backCover02Text,
    uploadedImage,
  } = state;

  const saveState = () => {
    let newState = {
      lang: lang,
      sec03textbox: sec03textbox,
      sec04textbox: sec04textbox,
      showPreview: showPreview,
      verticalImage: verticalImage,
      titleText: titleText,
      backCover01Text: backCover01Text,
      backCover02Text: backCover02Text,
      uploadedImage: uploadedImage,
    };
    callback(index, newState);
  };
  const previewRef = useRef();
  const changeState = (key, value) => {
    state[key] = value;
    callback(state);
  };
  const copyOptions = [];
  for (let i = 1; i < currentPageNumber; i++) {
    copyOptions.push(i + "個目と同じ");
  }
  copyOptions.push("別のデザインで作る");
  let copySelected = selectedCopyDetails + "個目の写真";
  const extractNumber = (s, currentPageNumber, totalPageNumber) => {
    for (let i = totalPageNumber; i > 0; i--) {
      if (s.includes(i)) {
        return i;
      }
    }
    return currentPageNumber;
  };

  const [verticalImage, setVerticalImage] = useState(state["verticalImage"]);
  function getBackCover01Text() {
    return sec03textbox === "その他（内容を入力する）"
      ? backCover01Text
      : sec03textbox;
  }
  function getBackCover02Text() {
    return sec04textbox === "その他（内容を入力する）"
      ? backCover02Text
      : sec04textbox === "表紙と同じ"
      ? titleText
      : sec04textbox;
  }
  useImperativeHandle(ref, () => ({
    changePreviewAlt,
  }));

  const changePreview = () => {
    domtoimage.toBlob(previewRef.current, { bgcolor: "white" }).then((blob) => {
      console.log("saving image again");
      const file = new File([blob], "image.png", { type: "image/png" });
      return file;
    });
    let element = document.getElementById("previewButton");
    window.scrollTo(0, element.offsetTop);
  };

  const changePreviewAlt = async () => {
    console.log("changed preview image");

    // Convert the copied HTML element to an image using dom-to-image
    try {
      const dataUrl = await domtoimage.toPng(previewRef.current, {
        bgcolor: "white",
      });

      // Create an image element and set its source to the captured image
      // const imgElement = new Image();
      // imgElement.src = dataUrl;
      // document.body.appendChild(imgElement);
      const blob = await fetch(dataUrl).then((res) => res.blob());
      const file = new File([blob], "image.png", { type: "image/png" });
      return file;
    } catch (e) {
      console.error(e);
      return false;
    }
  };

  function handleImageLoad(event) {
    const { naturalWidth, naturalHeight } = event.target;
    setVerticalImage(naturalWidth >= naturalHeight ? false : true);
    changePreview();
  }
  const uploadNewImage = () => {
    // saveState();
    image_selection_popup(index, 1);
  };
  return (
    <div className={styles.super_main_div}>
      <div className={styles.main_div}>
        <div className={styles.top_hr}></div>
        <div className={styles.header_section_main}>
          <div name="編　集" className={styles.header_section}>
            編　　集
          </div>
          {totalPageNumber > 1 && (
            <div
              className={styles.header_number}
              name={"editsection" + currentPageNumber}
            >
              {currentPageNumber + "個目"}
            </div>
          )}
        </div>
        {currentPageNumber > 1 && (
          <div className={styles.multi_page_selector}>
            <EditScreenSelector
              takeupspace={true}
              options={copyOptions}
              callback={(value) => {
                console.log(value);
                changeCopyDetails(
                  extractNumber(value, currentPageNumber, totalPageNumber),
                  index
                );
                // changeState("sec03textbox", value);
                // setSec03textbox(value);
              }}
              selected={copySelected}
            />
          </div>
        )}
        {(selectedCopyDetails === currentPageNumber ||
          currentPageNumber === 1) && (
          <div className={styles.edit_section}>
            <div className={styles.row_sample}>
              <div className={styles.sample_header_text}>表紙・背表紙</div>
              <img
                src={edit_1}
                alt="sample"
                className={styles.sample_pic}
                crossOrigin="anonymous"
              ></img>
            </div>
            <div className={styles.form_section}>
              {/* section 01 */}
              <div className={styles.section01}>
                <div className={styles.header_text01}>
                  1.タイトルの表記の仕方について選択してください。
                </div>
                <div className={styles.radio_section}>
                  <div className={styles.element}>
                    <div className={styles.radio_button}>
                      <input
                        className={styles.radio}
                        type="radio"
                        name={"language" + index.toString()}
                        checked={lang === "日本語表記（縦書き）"}
                        // defaultChecked
                        onChange={() => {}}
                        onClick={(event) => {
                          changeState("lang", "日本語表記（縦書き）");
                          // setLang("日本語表記（縦書き）");
                        }}
                      />
                    </div>
                    <div className={styles.radio_text}>
                      日本語表記（縦書き）
                    </div>
                  </div>
                  <div className={styles.element}>
                    <div className={styles.radio_button}>
                      <input
                        className={styles.radio}
                        type="radio"
                        onChange={() => {}}
                        name={"language" + index.toString()}
                        checked={lang === "アルファベット表記（横書き）"}
                        onClick={(event) => {
                          changeState("lang", "アルファベット表記（横書き）");
                          // setLang("アルファベット表記（横書き）");
                        }}
                      />
                    </div>
                    <div className={styles.radio_text}>
                      アルファベット表記（横書き）
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.section02}>
                <div className={styles.header_text02}>
                  2.　表紙に記載するお名前
                </div>
                <div className={styles.input_box}>
                  <textarea
                    placeholder="例1）　結人
例2）　Yuito
名前以外をご希望の方は内容をご記入ください"
                    type="textbox"
                    rows="3"
                    value={titleText}
                    onChange={(e) => {
                      changeState("titleText", e.target.value);
                      // setTitleText(e.target.value);
                    }}
                    className={styles.section02inputbox}
                  >
                    <pre>{titleText}</pre>
                  </textarea>
                </div>
              </div>
              <div className={styles.section03}>
                <div className={styles.header_text03}>
                  3.　背表紙①に記載する内容
                </div>
                <div className={styles.section03_select}>
                  {lang === "日本語表記（縦書き）" && (
                    <EditScreenSelector
                      options={[
                        "七五三",
                        "お宮参り",
                        "初誕生",
                        "その他（内容を入力する）",
                      ]}
                      callback={(value) => {
                        changeState("sec03textbox", value);
                        // setSec03textbox(value);
                      }}
                      selected={state["sec03textbox"]}
                      alignLeft={true}
                    />
                  )}
                  {lang === "アルファベット表記（横書き）" && (
                    <EditScreenSelector
                      options={[
                        "753",
                        "Omiyamairi",
                        "Half Birthday",
                        "1st Birthday",
                        "〇〇th Birthday",
                        "その他（内容を入力する）",
                      ]}
                      callback={(value) => {
                        changeState("sec03textbox", value);
                        // setSec03textbox(value)
                      }}
                      selected={state["sec03textbox"]}
                      alignLeft={true}
                    />
                  )}
                  {sec03textbox === "その他（内容を入力する）" && (
                    <div className={styles.input_box}>
                      <textarea
                        placeholder="内容をご記入ください"
                        type="textbox"
                        rows="3"
                        value={backCover01Text}
                        onChange={(event) => {
                          changeState("backCover01Text", event.target.value);
                          // setBackCover01Text(event.target.value);
                        }}
                        className={styles.section03inputbox}
                      ></textarea>
                    </div>
                  )}
                </div>
              </div>
              <div className={styles.section04}>
                <div className={styles.header_text04}>
                  4.　背表紙②に記載する内容
                </div>
                <div className={styles.section03_select}>
                  <EditScreenSelector
                    options={[
                      "表紙と同じ",
                      "その他（内容を入力する）",
                      "文字なし",
                    ]}
                    callback={(value) => {
                      changeState("sec04textbox", value);
                      // setSec04textbox(value);
                    }}
                    selected={state["sec04textbox"]}
                    alignLeft={true}
                  />
                  {sec04textbox === "その他（内容を入力する）" && (
                    <div className={styles.input_box}>
                      <textarea
                        placeholder="内容をご記入ください"
                        type="textbox"
                        rows="3"
                        value={backCover02Text}
                        onChange={(event) => {
                          changeState("backCover02Text", event.target.value);
                          // setBackCover02Text(event.target.value);
                        }}
                        className={styles.section03inputbox}
                      ></textarea>
                    </div>
                  )}
                </div>
              </div>
              <div className={styles.section05}>
                <div className={styles.sec05_top}>
                  <div className={styles.header_text05}>
                    5.ギャラリーから写真を選択してください。
                  </div>
                  <div className={styles.sub_header_text05}>
                    ※横写真は横向き、縦写真は縦向きで挿入されます。
                  </div>
                </div>
                {/* <EditScreenImageUpload image={horizontal_upload} /> */}
                <div className={styles.image_ph_left_margin}>
                  <EditScreenImageUpload
                    image={uploadedImage}
                    callback={uploadNewImage}
                    remove={() => {
                      changeState("uploadedImage", "");
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className={styles.finish_button_section}>
        <div className={styles.show_preview_button}>
          <button
            id="previewButton"
            onClick={(_) => {
              // setShowPreview(true);
              changePreview();
              changeState("showPreview", true);
            }}
          >
            イメージプレビュー
          </button>
        </div>
      </div>
      <div id="previewWrapper">
        {showPreview && (
          <>
            <div className={styles.preview_main_wrapper}>
              <div className={styles.preview_main_div}>
                <div className={styles.preview_hr}></div>
                <div className={styles.preview_header}>イメージプレビュー</div>
                {totalPageNumber > 1 && (
                  <div
                    className={styles.header_number_2}
                    name={"editsection" + currentPageNumber}
                  >
                    {currentPageNumber + "個目"}
                  </div>
                )}
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div ref={previewRef} className={styles.preview_section}>
                    <div className={styles.preview_column_1}>
                      <div className={styles.preview_sub_1}>背表紙タイトル</div>
                      <div className={styles.preview_column_main_01}>
                        <div
                          className={
                            JAPANESE_REGEX.test(getBackCover01Text())
                              ? styles.preview_column_main_01_top
                              : styles.preview_column_main_01_top_english
                          }
                          id="leftText1"
                        >
                          {/* 七五三 */}
                          {getBackCover01Text()}
                        </div>
                        <div
                          className={
                            JAPANESE_REGEX.test(getBackCover02Text())
                              ? styles.preview_column_main_02_top
                              : styles.preview_column_main_02_top_english
                          }
                          id="leftText2"
                        >
                          {/* 光輝 大輝 */}
                          {getBackCover02Text()}
                        </div>
                      </div>
                    </div>
                    <div className={styles.preview_column_2}>
                      <div className={styles.preview_sub_2}>タイトル</div>
                      <div className={styles.preview_column_main_02}>
                        <div className={styles.preview_title_div}>
                          {JAPANESE_REGEX.test(titleText) &&
                            titleText.split(" ").map((item, index) => {
                              return (
                                <div
                                  key={index}
                                  className={`${styles.preview_title_text_col} lang=ja`}

                                >
                                  {item}
                                </div>
                              );
                            })}
                          {!JAPANESE_REGEX.test(titleText) && (
                            <div
                              id="titleText"
                              className={`${styles.preview_title_text_col_eng}`}
                            >
                              {titleText.split("\n").map((item, i) => {
                                return <div key={i}>{item}</div>;
                              })}
                            </div>
                          )}
                        </div>

                        <div className={styles.preview_image_div}>
                          <div className={styles.preview_image_text}>
                            表紙写真
                          </div>
                          <div className={styles.preview_image_main}>
                            <img
                              src={uploadedImage}
                              onLoad={handleImageLoad}
                              alt={"uploaded_image"}
                              style={{
                                maxHeight: verticalImage ? "450px" : "300px",
                                maxWidth: !verticalImage ? "450px" : "300px",
                              }}
                              crossOrigin="anonymous"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.preview_section_2}>
                  <div className={styles.preview_column_4}>
                    {totalPageNumber > 1 && (
                      <div
                        className={styles.save_tag}
                        onClick={() => {
                          saveThisProduct();
                        }}
                      >
                        {currentPageNumber + "個目を保存"}
                      </div>
                    )}

                    <div className={styles.preview_info_text}>
                      タイトルや写真の配置は、バランスをみてデザイナーが調整いたします。指定はできませんので予めご了承ください。
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className={styles.confirm_edits_wrapper}>
        <div className={styles.confirm_edits}>
          <div className={styles.confirm_header}>
            上記の内容でデザイン決定しますか？
          </div>
          <div className={styles.confirm_button_section}>
            <Link
              to={
                totalPageNumber === 1
                  ? "編　集"
                  : "editsection" + currentPageNumber
              }
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
            >
              <button className={styles.confirm_button_no}>編集へ戻る</button>
            </Link>
            <button
              onClick={() => {
                if (totalPageNumber === 1) {
                  confirmEdits();
                } else {
                  if (currentPageNumber < totalPageNumber) {
                    const elementName = "editsection" + (currentPageNumber + 1);

                    scroller.scrollTo(elementName, {
                      spy: true,
                      smooth: true,
                      offset: -100,
                      duration: 500,
                    });
                  } else {
                    generatePreviewsAtBottom();
                  }
                }
              }}
              className={styles.confirm_button_yes}
            >
              はい
            </button>
          </div>
        </div>
      </div>
    </div>
  );
});
export default EditSectionReusable;
